export default {"src":"/_next/static/media/planets.58f92d94.svg","height":435,"width":474,"blurWidth":0,"blurHeight":0};